export default __webpack_public_path__ + "img/filter_CI.73320b932ee434e49cc843b165794682.jpg";